module.exports = __webpack_public_path__ + "media/customizations/granbyranch/logo-new-4d295639d45f777f80153a16d42de617.png";